import { render, staticRenderFns } from "./Katoennatie.vue?vue&type=template&id=32ce5590&"
import script from "./Katoennatie.vue?vue&type=script&lang=ts&"
export * from "./Katoennatie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports